export const ADMIN = 'Account Admin'
export const MEMBER = 'Member'
export const TOKEN_BUYER = 'Token Buyer'
